import { Button, Grid, ListItem, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NumberFormatCustom from '../../../NumberFormatCustom/NumberFormatCustom';
import { SupportSheetHelpTextConstant } from '../../models/SupportSheetHelperTextConstant';
import SupportSheetHelpText from '../SupportSheetHelpText/SupportSheetHelpText';
import SupportSheetAnalysisModel, { SupportSheetAnalysisPerformanceNoteModel } from './models/SupportSheetAnalysisModel';
import './SupportSheetAnalysis.scss';

interface SupportSheetAnalysisProp {
    item: SupportSheetAnalysisModel,
    initialVolume: number,
    initialComplexity: number,
    className?: string,
    onChange?: (selectedItem: SupportSheetAnalysisModel) => void,
}

export const getDefaultAnalysis = () => {
    return {
        postfixPICVolume: null,
        postfixPICComplexity: null,

        postfixPICQuality: null,
        postfixManagerQuality: null,
        brokerPICQuality: null,

        performanceNote: [{
            description: "",
            point: ""
        } as SupportSheetAnalysisPerformanceNoteModel],
    } as SupportSheetAnalysisModel;
}

const SupportSheetAnalysis: React.FunctionComponent<SupportSheetAnalysisProp> = (props) => {
    const dispatch = useDispatch();

    const getAvgVolComplex = () => {
        //sum (final V * final C) / 3
        let result = (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0);
        return result.toFixed(1);
    };

    const getAvgQuality = () => {
        //sum ( V *  C *  Q) chia [sum ( V *  C)]
        if (
            (
                !props.item.postfixPICVolume || props.item.postfixPICVolume == 0 ||
                !props.item.postfixPICComplexity || props.item.postfixPICComplexity == 0
            )
        ) {
            return 0;
        }

        let numerator = (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0) * (props.item.postfixPICQuality ?? 0) +
            (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0) * (props.item.postfixManagerQuality ?? 0) +
            (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0) * (props.item.brokerPICQuality ?? 0);

        let denominator = (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0) +
            (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0) +
            (props.item.postfixPICVolume ?? 0) * (props.item.postfixPICComplexity ?? 0);

        let result = numerator / denominator;
        return result.toFixed(1);
    };

    return (
        <>
            <div>
                <b>EVALUATION<SupportSheetHelpText helpText={SupportSheetHelpTextConstant['Analytics']}></SupportSheetHelpText></b>
            </div>
            <Table className="datatable support-sheet-analytics-table">
                <TableHead>
                    <TableRow className="datatable-head">
                        <TableCell className='support-sheet-analysis-cell'></TableCell>
                        <TableCell className='support-sheet-analysis-cell'>Initial</TableCell>
                        <TableCell className='support-sheet-analysis-cell'>Postfix PIC</TableCell>
                        <TableCell className='support-sheet-analysis-cell'>Postfix manager</TableCell>
                        <TableCell className='support-sheet-analysis-cell'>Broker PIC</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell className="datatable-cell-head support-sheet-analysis-cell">Volume</TableCell>
                        <TableCell className='support-sheet-analysis-cell'>
                            <TextField
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.initialVolume}
                                disabled={true}
                            />
                        </TableCell>
                        <TableCell className='support-sheet-analysis-cell ' colSpan={3}>
                            <TextField
                                fullWidth
                                className='postfix-vol-complex-input'
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.item.postfixPICVolume}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        props.item.postfixPICVolume = parseInt(event.target.value)
                                        props.onChange(props.item);
                                    }
                                }}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="datatable-cell-head support-sheet-analysis-cell">Complexity</TableCell>
                        <TableCell className='support-sheet-analysis-cell'>
                            <TextField
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.initialComplexity}
                                disabled={true}
                            />
                        </TableCell>
                        <TableCell className='support-sheet-analysis-cell' colSpan={3}>
                            <TextField
                                fullWidth
                                className='postfix-vol-complex-input'
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.item.postfixPICComplexity}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        props.item.postfixPICComplexity = parseInt(event.target.value)
                                        props.onChange(props.item);
                                    }
                                }}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="datatable-cell-head support-sheet-analysis-cell">Quality</TableCell>
                        <TableCell className="datatable-cell-head support-sheet-analysis-cell">
                        </TableCell>
                        <TableCell className='support-sheet-analysis-cell'>
                            <TextField
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.item.postfixPICQuality}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        props.item.postfixPICQuality = parseFloat(event.target.value)
                                        props.onChange(props.item);
                                    }
                                }}
                            />
                        </TableCell>
                        <TableCell className='support-sheet-analysis-cell'>
                            <TextField
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.item.postfixManagerQuality}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        props.item.postfixManagerQuality = parseFloat(event.target.value)
                                        props.onChange(props.item);
                                    }
                                }}
                            />
                        </TableCell>
                        <TableCell className='support-sheet-analysis-cell'>
                            <TextField
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={props.item.brokerPICQuality}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        props.item.brokerPICQuality = parseFloat(event.target.value)
                                        props.onChange(props.item);
                                    }
                                }}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <div>
                <div>
                    <div className='support-sheet-analysis-table-note'>
                        {getAvgVolComplex()}
                    </div>: Final Workload
                </div>
                <div>
                    <div className='support-sheet-analysis-table-note'>
                        {getAvgQuality()}
                    </div>: Final Quality
                </div>
            </div>
            <div>
                <b>POINT ADDITION/DEDUCTION</b>
            </div>
            <div>
                {props.item.performanceNote && props.item.performanceNote.map((item: SupportSheetAnalysisPerformanceNoteModel, index: number) => (
                    <Grid container className='cargo-input-component'>
                        <Grid item xs={8}>
                            <TextField
                                label='Description'
                                fullWidth
                                value={item.description}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        props.item.performanceNote[index].description = event.target.value;
                                        props.onChange(props.item);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label='Point'
                                fullWidth
                                value={item.point}
                                onChange={(event) => {
                                    if (props.onChange) {
                                        if (props.onChange) {
                                            props.item.performanceNote[index].point = event.target.value;
                                            props.onChange(props.item);
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid xs={1}>
                            <Button
                                className='table-action-button'
                                onClick={() => {
                                    if (props.onChange) {
                                        props.item.performanceNote.splice(index, 1);
                                        props.onChange(props.item);
                                    }
                                }}
                                variant='text'
                            >
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </Button>
                        </Grid>
                    </Grid>
                ))}
            </div>
            <div>
                <Button
                    color="secondary"
                    variant='outlined'
                    onClick={() => {
                        let newItem = {
                            description: "",
                            point: ""
                        } as SupportSheetAnalysisPerformanceNoteModel;

                        if (props.item.performanceNote) {
                            props.item.performanceNote.push(newItem);
                        } else {
                            props.item.performanceNote = [newItem];
                        }

                        if (props.onChange) {
                            props.onChange(props.item);
                        }
                    }}
                >
                    Add More
                </Button>
            </div>
        </>
    )
};

export default SupportSheetAnalysis;